module.exports = __webpack_public_path__ + "static/media/PinLocation.a79c1131.svg";